import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  HostListener,
  ViewChild,
  SimpleChanges
} from '@angular/core'
import { File } from 'app/models/file'
import { FileStatus } from 'app/models/file-status.enum'
import { FileType } from 'app/models/file-type.enum'
import { FilesService } from 'app/services/files.service'
import { Source } from 'app/models/source.enum'

@Component({
  selector: 'app-viewer-content',
  templateUrl: './viewer-content.component.html',
  styleUrls: ['./viewer-content.component.scss'],
  providers: [FilesService]
})
export class ViewerContentComponent implements OnInit, OnDestroy, OnChanges {

  @Input() file: File
  @Input() hide: boolean
  @Input() isAdmin: boolean

  @ViewChild('imgContainer') imgContainer: any
  status: string
  hoverState: string
  source: string
  fileType = FileType
  pdfSource: string

  constructor(private fileService: FilesService) {
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.hoverState = 'hoverOn'
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.hoverState = 'hoverOut'
  }

  ngOnDestroy(): void {
    this.status = FileStatus.Hide
  }

  ngOnInit() {
    this.status = FileStatus.Active
    this.hoverState = ''
    this.getFile()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.file.previousValue ||
      changes.file.currentValue.id !== changes.file.previousValue.id) {
      this.pdfSource = null
      this.source = null
      this.getFile()
    }
  }

  getFile() {
    if (this.file.contentType === FileType.Img || this.file.contentType === FileType.Doc) {
      this.getSharepointFile()
    }
  }

  getSharepointFile() {
    const id = this.file.source === Source.Document ? this.file.id : this.file.documentId
    if (id) {
      this.fileService
        .download(id)
        .subscribe((result) => {
          if (this.file.contentType === FileType.Img) {
            this.source = URL.createObjectURL(result.content)
          } else {
            this.pdfSource = URL.createObjectURL(result.content)
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/viewer-content/viewer-content.component.ts